// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zrdqr4H5wzA_yPgE {
  margin: 15px 32px 0;
}
.Zrdqr4H5wzA_yPgE .HekVp30U4uU1znBm {
  display: flex;
  align-items: center;
  gap: 24px;
}
.Zrdqr4H5wzA_yPgE .HekVp30U4uU1znBm .mTUvICwcelkRttFt {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.Zrdqr4H5wzA_yPgE .HekVp30U4uU1znBm .p7qJI7A_j1Q1BFzv {
  color: red;
  font-weight: bold;
  font-size: 14px;
}
.Zrdqr4H5wzA_yPgE .mmygCIftvIE1CWcM {
  display: flex;
  margin-top: 12px;
  gap: 16px;
}
.Zrdqr4H5wzA_yPgE .y3QQASRPkYcoqSVT {
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  width: 272px;
  height: 120px;
  border-radius: 8px;
  background: linear-gradient(180deg, #4cde67 0%, #31af87 100%);
  box-shadow: 0px 6px 14px 0px rgba(77, 212, 154, 0.5);
}
.Zrdqr4H5wzA_yPgE .iblZgg0jRnkJp02J {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #fff;
}
.Zrdqr4H5wzA_yPgE .iblZgg0jRnkJp02J .NuDRy2OiR5cDVvzW {
  font-size: 16px;
  font-weight: bold;
}
.Zrdqr4H5wzA_yPgE .iblZgg0jRnkJp02J .nHG2gwkAg3Mybjph {
  font-size: 12px;
  font-weight: normal;
}
.Zrdqr4H5wzA_yPgE .y3QQASRPkYcoqSVT .csoldvC08LkjHaD7 {
  width: 64px;
  height: 64px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.26) 100%);
  border: 1px solid #fff;
  border-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
}
.Zrdqr4H5wzA_yPgE .y3QQASRPkYcoqSVT .LUwULz8ZrMgDJy3Y,
.Zrdqr4H5wzA_yPgE .y3QQASRPkYcoqSVT img {
  width: 32px;
  height: 32px;
}
.Zrdqr4H5wzA_yPgE .v8UueRnL4dseFcs8 {
  background: linear-gradient(180deg, #7159f9 0%, #572bdb 100%);
  box-shadow: 0px 6px 14px 0px rgba(128, 96, 252, 0.5);
}
.Zrdqr4H5wzA_yPgE ._qgE3uD7wAwbeCcN {
  background: linear-gradient(180deg, #46b0ff 0%, #4466ff 100%);
  box-shadow: 0px 6px 14px 0px rgba(68, 126, 255, 0.5);
}
.Zrdqr4H5wzA_yPgE .Fe64kqRs0kYUbwT3 {
  background: linear-gradient(180deg, #f3c738 0%, #fc854e 100%);
  box-shadow: 0px 6px 14px 0px rgba(251, 142, 75, 0.5);
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Service/index.modules.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAFA;EAII,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAPA;EASM,eAAA;EACA,iBAAA;EACA,cAAA;AACN;AAZA;EAeM,UAAA;EACA,iBAAA;EACA,eAAA;AAAN;AAjBA;EAsBI,aAAA;EACA,gBAAA;EACA,SAAA;AAFJ;AAtBA;EA4BI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6DAAA;EACA,oDAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAHN;AADI;EAOI,eAAA;EACA,iBAAA;AAHR;AALI;EAYI,eAAA;EACA,mBAAA;AAJR;AA/CA;EAwDM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gGAAA;EAIA,sBAAA;EACA,8EAAA;AATN;AA1DA;;EA0EM,WAAA;EACA,YAAA;AAZN;AA/DA;EAgFI,6DAAA;EACA,oDAAA;AAdJ;AAnEA;EAqFI,6DAAA;EACA,oDAAA;AAfJ;AAvEA;EA0FI,6DAAA;EACA,oDAAA;AAhBJ","sourcesContent":[".wrapper {\n  margin: 15px 32px 0;\n\n  .titleWrapper {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n\n    .title {\n      font-size: 16px;\n      font-weight: bold;\n      color: #333333;\n    }\n\n    .announcement {\n      color: red;\n      font-weight: bold;\n      font-size: 14px;\n    }\n  }\n\n  .content {\n    display: flex;\n    margin-top: 12px;\n    gap: 16px;\n  }\n\n  .item {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    cursor: pointer;\n    width: 272px;\n    height: 120px;\n    border-radius: 8px;\n    background: linear-gradient(180deg, #4cde67 0%, #31af87 100%);\n    box-shadow: 0px 6px 14px 0px rgba(77, 212, 154, 0.5);\n\n    &TitleContent {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      color: #fff;\n\n      .itemTitle {\n        font-size: 16px;\n        font-weight: bold;\n      }\n\n      .itemDesc {\n        font-size: 12px;\n        font-weight: normal;\n      }\n    }\n\n    .icon {\n      width: 64px;\n      height: 64px;\n      border-radius: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(180deg,\n          rgba(255, 255, 255, 0.5) 0%,\n          rgba(255, 255, 255, 0.26) 100%);\n\n      border: 1px solid #fff;\n      border-image: linear-gradient(180deg,\n          #ffffff 0%,\n          rgba(255, 255, 255, 0) 100%);\n    }\n\n    .image,\n    img {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .help {\n    background: linear-gradient(180deg, #7159f9 0%, #572bdb 100%);\n    box-shadow: 0px 6px 14px 0px rgba(128, 96, 252, 0.5);\n  }\n\n  .dataService {\n    background: linear-gradient(180deg, #46b0ff 0%, #4466ff 100%);\n    box-shadow: 0px 6px 14px 0px rgba(68, 126, 255, 0.5);\n  }\n\n  .complaints {\n    background: linear-gradient(180deg, #f3c738 0%, #fc854e 100%);\n    box-shadow: 0px 6px 14px 0px rgba(251, 142, 75, 0.5);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Zrdqr4H5wzA_yPgE`,
	"titleWrapper": `HekVp30U4uU1znBm`,
	"title": `mTUvICwcelkRttFt`,
	"announcement": `p7qJI7A_j1Q1BFzv`,
	"content": `mmygCIftvIE1CWcM`,
	"item": `y3QQASRPkYcoqSVT`,
	"itemTitleContent": `iblZgg0jRnkJp02J`,
	"itemTitle": `NuDRy2OiR5cDVvzW`,
	"itemDesc": `nHG2gwkAg3Mybjph`,
	"icon": `csoldvC08LkjHaD7`,
	"image": `LUwULz8ZrMgDJy3Y`,
	"help": `v8UueRnL4dseFcs8`,
	"dataService": `_qgE3uD7wAwbeCcN`,
	"complaints": `Fe64kqRs0kYUbwT3`
};
export default ___CSS_LOADER_EXPORT___;
